import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import LandingPage from './pages/LandingPage';
import GlobalStyles from './styles/GlobalStyles';

const lightTheme = {
  colors: {
    primary: '#2563EB',
    secondary: '#3B82F6',
    accent: '#60A5FA',
    background: '#FFFFFF',
    surface: '#EFF6FF',
    text: '#1E3A8A',
    textSecondary: '#3B82F6',
  },
  breakpoints: {
    mobile: '768px',
  }
};

const darkTheme = {
  colors: {
    primary: '#60A5FA',
    secondary: '#3B82F6',
    accent: '#1E40AF',
    background: '#0A1929',
    surface: '#0F2942',
    text: '#F3F4F6',
    textSecondary: '#94A3B8',
  },
  breakpoints: {
    mobile: '768px',
  }
};

function App() {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    return savedTheme ? savedTheme === 'dark' : window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  useEffect(() => {
    localStorage.setItem('theme', isDarkMode ? 'dark' : 'light');
  }, [isDarkMode]);

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
    // Fix for mobile scrolling after theme change
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, parseInt(scrollY || '0'));
  };

  return (
    <ThemeProvider theme={isDarkMode ? darkTheme : lightTheme}>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <GlobalStyles />
        <Navbar isDarkMode={isDarkMode} toggleTheme={toggleTheme} />
        <LandingPage />
        <Footer />
      </Router>
    </ThemeProvider>
  );
}

export default App;